import React, { useState, useRef } from 'react';
import RegenerateIcon from '../../assets/RegenerateIcon';
import EditIcon from '../../assets/EditIcon';

interface SectionHeaderProps {
  title: string;
  onRegenerate?: (e: React.MouseEvent) => void;
  onEdit?: (e: React.MouseEvent) => void;
  showRegenerateIcon?: boolean;
  showEditIcon?: boolean;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ 
  title, 
  onRegenerate,
  onEdit,
  showRegenerateIcon = true,
  showEditIcon = true
}) => {
  const [isRegenerateHovered, setIsRegenerateHovered] = useState(false);
  const [isEditHovered, setIsEditHovered] = useState(false);
  
  const handleRegenerateClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onRegenerate) {
      onRegenerate(e);
    }
  };

  const handleEditClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onEdit) {
      onEdit(e);
    }
  };

  return (
    <div className="flex items-center justify-between mb-2">
      <span className="text-sm font-medium uppercase text-primary">{title}</span>
      <div className="flex items-center gap-2">
        {showEditIcon && (
          <div 
            onClick={handleEditClick}
            onMouseEnter={() => setIsEditHovered(true)}
            onMouseLeave={() => setIsEditHovered(false)}
            className="cursor-pointer"
          >
            <EditIcon className={isEditHovered ? "text-blue-500" : ""} />
          </div>
        )}
        {showRegenerateIcon && (
          <div 
            onClick={handleRegenerateClick}
            onMouseEnter={() => setIsRegenerateHovered(true)}
            onMouseLeave={() => setIsRegenerateHovered(false)}
            className="cursor-pointer"
          >
            <RegenerateIcon className={isRegenerateHovered ? "text-purple-500" : ""} />
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionHeader;